import request from './request'
export function getIndexContentApi() {
    return request({
      url: "/website/getIndexContent",
      method: "post",
      params: {}
    });
  }